export default __webpack_public_path__ + "static/media/Logos.c75af2cc.png";